import React, { useState, useEffect } from 'react'

const Covid = () => {
  const [states, setStates] = useState([]);
  const [stateId, setStateId] = useState("");
  const [districts, setDistricts] = useState([]);
  const [districtId, setDistrictId] = useState("");
  const [date, setDate] = useState("");
  const [vaccineCenters, setVaccineCenters] = useState([]);

  useEffect(() => {
    const getStatesData = async () => {
      try {
        const res = await fetch('https://cdn-api.co-vin.in/api/v2/admin/location/states');
        const data = await res.json();
        setStates(data.states);
        console.log(data);
      } catch (err) {
        console.log(err);
      }
    }
    getStatesData();
  }, []);

  const handleStateChange = async (e) => {
    const stateId = e.target.value;
    setStateId(stateId);
    try {
      const res = await fetch(`https://cdn-api.co-vin.in/api/v2/admin/location/districts/${stateId}`);
      const data = await res.json();
      setDistricts(data.districts);
      console.log(data);
    } catch (err) {
      console.log(err);
    }
  }


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let temp = date.split('-');
      let newdate = temp[2] + "-" + temp[1] + "-" + temp[0];
      const res = await fetch(`https://cdn-api.co-vin.in/api/v2/appointment/sessions/public/calendarByDistrict?district_id=${districtId}&date=${newdate}`);
      const data = await res.json();
      setVaccineCenters(data.centers);
      console.log(data);
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <>

      <div>
        <div className='text-center font-bold font-medium pt-9'>COVID-19 Vaccination Slots Finder </div>
        <p className='text-center text-gray-500'>Most of the locations does not have vaccination center so try checking Dist- Central delhi, Cuttack, etc</p>
        <div className="flex justify-center py-10">
          <form onSubmit={handleSubmit} className="relative md:flex justify-center items-center gap-8 space-y-4  ">
            <div className= " rounded  px-8 pt-2.5 pb-2 font-medium shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] "
>
              <select value={stateId} onChange={handleStateChange} required>
                <option value="" >Select a state</option>
                {states.map(state => (
                  <option key={state.state_id} value={state.state_id} >{state.state_name}</option>
                ))}
              </select>
            </div>
            <div className='rounded px-8 pt-2.5 pb-2 font-medium shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]'>
              <select value={districtId} onChange={(e) => setDistrictId(e.target.value)} required>
                <option value="">Select a district</option>
                {districts.map(district => (
                  <option key={district.district_id} value={district.district_id}>{district.district_name}</option>
                ))}
              </select>
            </div>


            <div className='rounded  px-8 pt-2.5 pb-2 font-medium shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]'>
              <input id="date" type="date" value={date} onChange={(e) => setDate(e.target.value)} required />
            </div>
            <button type="submit" className=' bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-20 border border-blue-500 hover:border-transparent rounded bg-blue-500 shadow-lg shadow-blue-500/50'>
                Search
              </button>
          </form>
        </div>
        <div className='text-center space-y-4 '>

          <span className='bg-orange-400 hover:bg-orange-500 text-white font-bold py-2 px-4 rounded'>
            Available vaccine centers: #   
            {vaccineCenters.length}
          </span>

          {vaccineCenters.map(center => (
            <div key={center.center_id}>
              <div className='space-y-6 py-8'>
                <spn className= " text-black-600 font-black bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded "> Name : {center.name}</spn>
                <p className='text-black-600 font-black'>Location: {center.address}</p>
                
              </div>

              {center.sessions.map(session => (
                <div key={`${center.center_id}-${session.date}`}>

                  {center.vaccine_fees.map(fee => (
                    <div key={`${center.center_id}-${session.date}`}>

                      <div className="container items-center flex justify-center mx-auto p-6 max-w-md mx-auto rounded-2xl shadow-2xl flex items-center space-x-4 shrink-0 ">
                        <div className="flex flex-col  ">
                          <div className="w-full ">
                            <div className=" shadow-2xl shadow-lg shadow-orange-300/50 transition ease-in-out  hover:-translate-y-1 hover:scale-110 duration-300 rounded-2xl ">

                              <table className="divide-y divide-gray-300 w-full flex-row flex-no-wrap md:bg-white rounded-lg overflow-hidden md:shadow-lg my-5 ">
                                <thead className="bg-gray-50  ">
                                  <tr className='bg-orange-200 flex flex-col flex-no wrap md:table-row rounded-l-lg md:rounded-none mb-2 md:mb-0'>
                                    <th className="px-6 py-2  p-3 text-left font-semibold">
                                      DATE
                                    </th>
                                    <th className="px-6 py-2  p-3 text-left font-semibold ">
                                      FREE/PAID
                                    </th>
                                    <th className="px-6 py-2  p-3 text-left font-semibold">
                                      FEE
                                    </th>
                                    <th className="px-6 py-2  p-3 text-left font-semibold">
                                      VACCINE
                                    </th>
                                    <th className="px-6 py-2  p-3 text-left font-semibold">
                                      CAPACITY
                                    </th>
                                    <th className="px-6 py-2  p-3 text-left font-semibold">
                                      AGE
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-300 flex-1 md:flex-none ">
                                  <tr className="whitespace-nowrap flex flex-col flex-no wrap md:table-row mb-2 md:mb-0 ">

                                    <td className="px-6 border-grey-light border hover:bg-gray-100 p-3  ">
                                      {session.date}
                                    </td>

                                    <td className="px-6 py-4 border-grey-light border hover:bg-gray-100 p-3 ">
                                    <span className="px-4 py-1 text-black-400 bg-red-300 rounded-full">

                                      # {center.fee_type}
                                      </span>
                                    </td>

                                    <td className="px-6 py-4 border-grey-light border hover:bg-gray-100 p-3">
                                    <span>&#8377;</span> {fee.fee}
                                    </td>

                                    <td className="px-6 py-4 border-grey-light border hover:bg-gray-100 p-3">
                                      {fee.vaccine}
                                    </td>

                                    <td className="px-6 py-4 border-grey-light border hover:bg-gray-100 p-3">      
                                        {session.available_capacity}
                                    </td>

                                    <td className="px-6 py-4 border-grey-light border hover:bg-gray-100 p-3">
                                      <span className="px-4 py-1 text-black-400 bg-green-300 rounded-full">
                                        {session.min_age_limit} +
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>))}
                </div>))}
            </div>))}
        </div>
      </div>
    </>
  )
}
export default Covid

